Vue.component('ack-image', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-image',
	mounted() {},
	props: {
		imageInfo: {
			// :product-info
			type: Object,
			required: true,
		},
		titleTag: {
			type: String,
			required: false,
		},
	},
	computed: {},
	data() {
		return {};
	},
	methods: {},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
